module.exports = __webpack_public_path__ + "img/sy-pic6.16ff8866.png";